import { render, staticRenderFns } from "./NewCommentRow.vue?vue&type=template&id=2b0fb89c&scoped=true&"
import script from "./NewCommentRow.vue?vue&type=script&lang=ts&"
export * from "./NewCommentRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0fb89c",
  null
  
)

export default component.exports